<template>
<div >

<spinner v-bind:spinner='spinner'></spinner>

<promoProduct  v-bind:productId="item.productId"></promoProduct>

  <div class="row mt-3">

  <div class="col-4">  
    <div v-if="company.Id == 1" style="" class="form-check mb-3 ml-3">

      <input @click="updateProductClub()" class="form-check-input" type="checkbox" value="" id="defaultCheck3" v-model="noClub">
    
      <label style="color:blueviolet" class="form-check-label" for="defaultCheck3">
      <strong>ESCLUDI DA CLUB</strong>
      </label>

    </div>
      

    <div v-if="!typeId" style="" class="form-check mb-0 ml-3">

      <input @click="updateEdit()" class="form-check-input" type="checkbox" value="" id="defaultCheck1" v-model="edit">
    
      <label style="color:black" class="form-check-label" for="defaultCheck1">
      <strong>BLOCCA MODIFICA ALLA CASSA</strong>
      </label>

    </div>
    <div  v-if="!typeId" style="" class="form-check mb-3 ml-3">

      <input @click="updateNoPromo()" class="form-check-input" type="checkbox" value="" id="defaultCheck2" v-model="noPromo">

      <label style="color:black" class="form-check-label" for="defaultCheck2">
      <strong>ESCLUDI DA PROMO SALDI</strong>
      </label>

    </div>


    <label style="color:black" for="retailPrice"><strong>
        <span>prezzo di vendita BASE €</span>
        </strong></label>                 
        <div  class="input-group mb-2">
        <input v-on:keydown="keyHandler($event,'Dec')" v-focus type="number" class="form-control" placeholder="prezzo di vendita BASE" v-model.number="retailPrice">

    <div class="input-group-append">
      
      <button @click="copyPrice()" class="btn btn-secondary" type="button" data-toggle="tooltip" title="Associa prezzo BASE a misura">
          <i  class="far fa-copy ml-1" aria-hidden="true"></i>
      </button>

    </div>

  </div>

  </div>

  </div>

  <div>              
  <table class="table table-sm"  id="priceList">
    <thead class="thead-light">
      <tr>
        <th 
        class = "text-center"
         v-bind:style="{ color: 'blue', backgroundColor : '#9ACD32' }"
         v-for="(col,index) in items" :key="index">
          <!--  <small class="form-text text-muted">Mis.</small> -->
            <span  
            class=""
            >{{col['size']}}</span>
            
        </th>
      </tr>
    </thead>
    <tbody>
      <tr >

        <td v-for="(col,index) in items" :key="index" >
        <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">€</div>
        </div>
            <input v-on:keydown="keyHandler($event,'Dec')" v-model.number = "col['price']" class="form-control bold"   v-bind:name="'id_' + index " type="number" v-bind:placeholder="'Prezzo di Listino '">
           </div>
        </td>

      </tr>
    </tbody>
  </table>

<div class="row mb-3">
<div class="col-auto">  
<label for="Sconto"><strong>Sconto listino</strong></label>
<div class="input-group">
  <div class="input-group-prepend">
    <div class="input-group-text">%</div>
  </div>
  <input v-on:keydown="keyHandler($event,'Num')" v-model="discount" type="number" class="form-control bold " placeholder="" name="discount" id = "__discount">
</div>

</div>
</div>

<!--<label-price-list v-if="!typeId"  :key="refresh" @update="setLabel" v-bind:product="product"></label-price-list>-->

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <button :disabled="items.length==0" @click="submit()"  class="btn btn-primary float-right mt-4">
    <i class="fas fa-edit mr-2 " aria-hidden="true"></i>
    
    MODIFICA
    <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>

  </button>
 
   
 </div>

</div>

<!--
</div>
</div> 
-->

</template>

<script>


import api                from "@/api"
import alertBox           from '@/components/common/AlertBox.vue';
import spinner            from '@/components/common/Spinner.vue';

import labelPriceList     from '@/components/backOffice/ready/LabelPriceList.vue'
import promoProduct       from '@/components/backOffice/ready/tab/PromoProduct.vue'
import keyHandler         from '@/components/mixins/keyHandler'

import {mapGetters }    from 'vuex';
export default {
   props : ['item','typeId'],
   mixins: [keyHandler],
   
   components: {alertBox,spinner,labelPriceList,promoProduct},  
  

  data () {
    return {
      noClub          : false,
      noPromo         : false, 
      edit            : false,
      refresh         : 0,
      items           : [],
      retailPrice     : 0,
      discount        : 0,
      
      msg             : {
        title : ''
      },
      
      spinner         : false,

      //product         : {sizes:[]},
      //labels          : []
      
    }
  },

   directives: 
    {

      focus: {
      
      inserted: function (el) 
      {
       
        el.focus() 
      
      }
      
      }

    },
      computed :{
   
     ...mapGetters(['company']),
     },
  mounted()
    {
       
        this.getData()
     
    },
  created()
  {
       
  
  },

  methods: 
  {
   /*
    setLabel(items)
    {
      this.labels = items
      //console.log(items)
    },
*/
    async updateProductClub()
    {
       this.msg.title = ''
      this.spinner  = true          
      const data      = {'productId' : this.item.productId,'insert': this.noClub ? 0:1 }
  
      const sp        = {'sp' : 'spCreateClubExcludedProducts'}
      const json      = Object.assign(data, sp);
      await api.post(json).then(res => {
        if(res.status==200)
        {
          this.msg.title = 'MODIFICA PRODOTTO EFFETTUATA. '
          this.msg.body = ''
          this.msg.type = 0
        }  
      else if(res.status==500)
      {                               
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res.data
        this.msg.type = 1              
                
      } 
      else
      {                                     
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res
        this.msg.type = 1                               
      } 
      

          }).catch(err => {
              
              
              
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                

              
          }).finally(() => {
          this.spinner = false
        });


    },
    async updateEdit()
    {
      this.msg.title = ''
      this.spinner  = true          
      const data      = {'productId' : this.item.productId,'edit':this.edit ? 0:1 }
  
      const sp        = {'sp' : 'spUpdateProductEditCart'}
      const json      = Object.assign(data, sp);
      await api.post(json).then(res => {
        if(res.status==200)
        {
          this.msg.title = 'MODIFICA "BLOCCO MODIFICA ALLA CASSA" EFFETTUATA. '
          this.msg.body = ''
          this.msg.type = 0
        }  
      else if(res.status==500)
      {                               
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res.data
        this.msg.type = 1              
                
      } 
      else
      {                                     
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res
        this.msg.type = 1                               
      } 
      

          }).catch(err => {
              
              
              
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                

              
          }).finally(() => {
          this.spinner = false
        });


    },
    async updateNoPromo()
    {

      this.msg.title = ''
      this.spinner  = true
          
      const data      = {'productId' : this.item.productId,'noPromo':this.noPromo ? 0:1}
  
      const sp        = {'sp' : 'spUpdateProductNoPromo'}
      const json      = Object.assign(data, sp);
      await api.post(json).then(res => {
        if(res.status==200)
        {
        
          this.msg.title = 'MODIFICA "ESCLUDI DA PROMO SALDI" EFFETTUATA.'
          this.msg.body = ''
          this.msg.type = 0        
      }  
      else if(res.status==500)
      {                               
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res.data
        this.msg.type = 1              
                
      } 
      else
      {                                     
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res
        this.msg.type = 1                               
      } 
      

          }).catch(err => {
              
              
              
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                

              
          }).finally(() => {
          this.spinner = false
        });


    },
    async getData()
    {
    
    this.spinner  = true
    
    const data      = {'productId' : this.item.productId}
    const sp        = {'sp' : 'spProductPriceListNew'}

    const json      = Object.assign(data, sp);
    await api.post(json).then(res => {
      if(res.status==200)
      {
        this.items = res.data.recordsets[0]                  
        this.discount = 0
        this.discount = res.data.recordsets[1].length > 0 ? res.data.recordsets[1][0].discount : 0
        
       

        if(res.data.recordsets[2].length>0) 
        {
          this.edit = res.data.recordsets[2][0].edit == 1 ? true : false
        }
        if(res.data.recordsets[3].length>0) 
        {
          this.noPromo = res.data.recordsets[3][0].NoPromo ? true : false
        }
        if(res.data.recordsets[4].length > 0) 
        {
          
          this.noClub = res.data.recordsets[4][0].noClub ? true : false
          
        }

        this.refresh++
        
      }  
      else if(res.status==500)
      {                               
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res.data
        this.msg.type = 1              
                
      } 
      else
      {                                     
        this.msg.title = 'ATTENZIONE '
        this.msg.body = res
        this.msg.type = 1                               
      } 
      

          }).catch(err => {
              
              
              
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type = 1                

              
          }).finally(() => {
          this.spinner = false
        });


    
    },  
    formatEuro(v)
    {
      const formatter = new Intl.NumberFormat('de-DE', {
      //style      : 'currency',
      minimumFractionDigits : 2, 
      maximumFractionDigits : 2,
      currency              : 'EUR',
    });

      return formatter.format(v); 
    },
   
  
    submit() 
      {
               
        this.msg.title = ''
        let err = false
        this.items.forEach(item => {

            
            if(this.formatEuro(item.price) == '0,00')
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = "Prezzo di vendita non valido per la misura " + ' ' + item.size
              this.msg.type = 1
              err = true
                                          
            }                      
          
        })
        
        if(err)
        {                    
          return
        }
        
         
        var data                = {}
        data.header             = {}
        data.body               = {}
        data.labels             = this.labels

        
        data.header.productId   = this.item.productId
        data.header.discount    = parseInt(this.discount)

       
        var arr                 = []
        this.items.forEach(item => {
          
            arr.push({'id' : item.id ,'price' : parseFloat(item.price).toFixed(2)})
                    
        })
        
        data.body.priceList       = arr
        
        this.saveData(data)

        //console.log(data)
        
        
      },
    async saveData(data)
    {

        const sp       = {'sp':'spUpdateProductPriceListNew'}
        this.spinner = true 
        const json = Object.assign(data, sp);
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
              this.msg.title = 'MODIFICA  EFFETTUATA.'
              this.msg.body = ''
              this.msg.type = 0
              
            }
           else if(res.status==500)
           {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
              
           } 
           else
            {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1
            } 
          

          }).catch(err => {
              
            
              
              this.msg.title = 'ATTENZIONE '
              this.msg.title = err.message             
              this.msg.type = 1
              
              
          }).finally(() => {
              this.spinner = false
        });
        
          
    },
    
    copyPrice()
      {
               
        if(this.formatEuro(this.retailPrice) == '0,00')
        {
            this.msg.title = 'ATTENZIONE '
            this.msg.body = "Prezzo di vendita BASE non valido." 
            this.msg.type = 1

            
            
            return
        }
        
        this.items.forEach(item =>{
            
            var num = this.retailPrice
            item.price = num.toFixed(2)
        })
       
        
      }
      
  }
  
}
</script>

<style scoped>
    h4 {
      font-family: 'Roboto Condensed';
      font-size: 20px;
    }
    .bold
    {
        font-weight  : bold;
    }
    
    label{
      _color  :  blue
    }
    p {
      font-family  : 'Roboto Condensed';
      font-size    : 25px;
    }
    span {
      font-family  : 'Roboto Condensed';
      font-size    : 15px;
    }
    .form-check-input 
    {
      
      cursor : pointer; 
    }
    .form-check-label
    {
      cursor : pointer; 
    }





</style>